var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "fx-event-listing-date-component" }, [
    _vm.event.is_date_tbd
      ? _c("div", [
          _c("span", { staticClass: "date-row" }, [_vm._v("Date")]),
          _vm._v(" "),
          _c("span", { staticClass: "date-row" }, [_vm._v("TBD")])
        ])
      : _vm.event.is_time_tbd
      ? _c("div", [
          _c("span", { staticClass: "date-row" }, [
            _vm._v(_vm._s(_vm._f("date")(_vm.event.local_date, "ddd")))
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "date-row", attrs: { "data-e2e": "event-date" } },
            [_vm._v(_vm._s(_vm._f("date")(_vm.event.local_date, "MMM D")))]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "date-row" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("date")(_vm.event.local_date, "YYYY")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      : _c("div", [
          _c("span", { staticClass: "date-row" }, [
            _vm._v(_vm._s(_vm._f("date")(_vm.event.local_date, "ddd")))
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "date-row", attrs: { "data-e2e": "event-date" } },
            [_vm._v(_vm._s(_vm._f("date")(_vm.event.local_date, "MMM D")))]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "date-row" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm._f("date")(_vm.event.local_date, "YYYY")) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "date-row" }, [
            _vm._v(_vm._s(_vm._f("date")(_vm.event.local_date, "h:mma")))
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "date-row time-tbd" }, [
      _c("span", { staticClass: "icon-clock" }),
      _vm._v("\n            TBD\n        ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }